<!--
 * @Author: 毛萍萍
 * @Date: 2021-07-06 14:46:06
 * @LastEditTime: 2023-02-14 15:50:43
 * @LastEditors: pingping.mao
 * @Description: 展示计量单位列表，搜索、新增、删除、批量删除、导入、导出
 * @FilePath: \common-web\src\views\standard\parameter-template\list.vue
-->
<template>
  <tree-list-layout-adapter :left-panel-enable="false" :right-top-panel-enable="false">
    <template #datatable>
      <div style="padding-top:24px;" class="h100">
        <GeneralTable
          ref="customTable"
          code="PARAMETER_TEMPLATE_LIST"
          :loading="tableLoading"
          :batch-delete="false"
          :version="2"
          :data="tableData"
          :pagination="pagination"
          :columns="tableColumns"
          @refresh="handleRefresh"
          @handleSizeChange="handlePaginationChange"
          @handleCurrentChange="handlePaginationChange"
          @batchDeleteData="deleteData"
        >
          <template #operation="{ scope }">
            <el-button
              v-if="isSystem ? true : visibleResource('parameter-template_edit_button')"
              type="text"
              class="btn__text--no-padding"
              @click="handleModalShow(scope.row, 'edit')"
            >
              {{ isSystem ? $t("public.edit") : getLabel('parameter-template_edit_button') }}
            </el-button>
            <el-button
              v-if="isSystem ? true : visibleResource('parameter-template_detail_button')"
              type="text"
              class="btn__text--no-padding"
              @click="handleModalShow(scope.row, 'details')"
            >
              {{ isSystem ? $t("public.details") : getLabel('parameter-template_detail_button') }}
            </el-button>
            <el-button
              v-if="isSystem ? true : visibleResource('parameter-template_delete_button')"
              type="text"
              class="btn__text--no-padding btn__text--red"
              @click="handleDeleteShow(scope.row)"
            >
              {{ isSystem ? $t("public.delete") : getLabel('parameter-template_delete_button') }}
            </el-button>
          </template>
          <div slot="tableSearchContent">
            <div class="search">
              <el-form
                :inline="true"
                :model="searchForm"
                class="demo-form-inline"
                @submit.native.prevent
              >
                <el-form-item>
                  <el-input
                    v-model="searchForm.value"
                    clearable
                    style="width: 316px"
                    :placeholder="$t('parameterTemplate.searchPlaceholder')"
                    @keyup.enter.native="handleSearch"
                  >
                    <div slot="suffix" class="search-input__icon--search">
                      <svg-icon
                        icon-class="search"
                        class="search-icon cursor-p"
                        @click="handleSearch"
                      ></svg-icon>
                    </div>
                  </el-input>
                </el-form-item>
                <el-form-item class="float-right" style="margin-right: 0">
                   <el-button
                    v-if="isSystem"
                    type="primary"
                    @click="handleSyncSingle()"
                  >
                    {{$t("common.issue")}}
                  </el-button>
                  <el-button
                    v-if="isSystem ? true : visibleResource('parameter-template_add_button')"
                    icon="el-icon-circle-plus-outline"
                    type="primary"
                    @click="handleModalShow({}, 'add')"
                  >
                    {{ isSystem ? $t("public.add") : getLabel('parameter-template_add_button') }}
                  </el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </GeneralTable>
        <!-- /表格 -->
      </div>

      <!-- 表格删除确认框 -->
      <delete-dialog
        layout="left"
        :visible.sync="deleteDialogVisible"
        :content="deleteContent"
        :loading.sync="deleteLoading"
        @confirm="handleDeleteConfirm"
      />
      <!-- 新增|编辑|详情 -->
      <ParameterTemplateAdd  v-if="dialogFormVisible" :visible.sync="dialogFormVisible" :propsData="formData" :type="formType" @success="refreshTable" />
      <!-- 下发 -->
      <sync-parameter v-if="syncDialogVisible" :visible.sync="syncDialogVisible" />
    </template>
  </tree-list-layout-adapter>
</template>

<script>
import { mapGetters } from 'vuex';
import DeleteDialog from '@/components/common/Dialogs/DeleteDialog';
import TreeListLayoutAdapter from '@/layout/components/TreeListLayoutAdapter';
import ParameterTemplateAdd from "./add.vue";
import SyncParameter from './inner-components/sync-parameter';
import parameterApi from '@/api/parameter-template';
import { updatePageNum } from '@/utils';
import { schemaMixins } from '@/mixin/schema';
export default {
  name: 'ParameterTemplate',
  components: {
    DeleteDialog,
    TreeListLayoutAdapter,
    ParameterTemplateAdd,
    SyncParameter
  },
  mixins: [schemaMixins],
  data() {
    return {
      resourceCode: 'parameter-template-list',
      searchForm: {
        value: ''
      },
      tableLoading: false,
      tableColumns: [
        {
          label: '所属模块',
          key: 'belongModule',
          width: '200',
          fixed: false
        },
        {
          label: '所属模块名称',
          key: 'belongModuleName',
          width: '200',
          fixed: false
        },
        {
          label: '描述',
          key: 'unitTypeName',
          width: 'auto',
          fixed: false
        },
        {
          label: '创建时间',
          key: 'createTime',
          width: '180',
          fixed: false
        }
      ],
      tableData: [],
      pagination: {
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      dialogFormVisible: false,
      formData: {},
      formType: 'add',
      deleteDialogVisible: false,
      deleteLoading: false,
      deleteContent: {
        title: this.$t('common.popupDelete.title'),
        description: this.$t('common.popupDelete.description')
      },
      uploadData: {},
      deleteRows: [],
      syncDialogVisible: false
    };
  },
  computed: {
    ...mapGetters(['isSystem'])
  },
  watch: {
    'searchForm.value'(newVal, oldVal) {
      if (!newVal && oldVal) {
        this.handleSearch();
      }
    }
  },
  created() {
    this.getList();
  },
  methods: {
    handleRefresh() {
      this.$emit('refresh');
    },
    // 获取列表数据
    getList() {
      this.tableData = [];
      this.tableLoading = true;
      const params = {
        searchKey: this.searchForm.value
      };
      parameterApi.getParamsTemplate(params)
        .then(res => {
          this.tableLoading = false;
          if (res.success) {
            this.tableData = res.data;
          }
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    // 搜索
    handleSearch() {
      this.pagination.pageNum = 1;
      this.getList();
    },
    // 条数改变|页数改变
    handlePaginationChange(data) {
      this.$set(this, 'pagination', data);
      this.getList();
    },
    // 添加|编辑
    handleModalShow(data = {}, type = '') {
      this.formData = data;
      this.formType = type;
      this.dialogFormVisible = true;
    },
    // 新增、编辑等弹框保存成功后回调：刷新列表
    refreshTable() {
      this.getList();
    },
    // 删除
    handleDeleteShow(row) {
      this.deleteRows = [row.id];
      this.deleteDialogVisible = true;
    },
    // 多条删除
    deleteData(data) {
      this.deleteRows = data.map(res => res.id);
      this.deleteDialogVisible = true;
    },
    // 删除提交
    handleDeleteConfirm() {
      this.deleteLoading = true;
      parameterApi.deleteModule({ id: this.deleteRows[0] })
        .then(res => {
          this.deleteLoading = false;
          if (res.success) {
            this.deleteDialogVisible = false;
            this.$message.success(this.$t('public.successfullyDeleted'));
            updatePageNum(this.deleteRows, this.pagination);
            this.getList();
          }
        })
        .catch(() => {
          this.deleteLoading = false;
        });
    },
    handleSyncSingle() {
      this.syncDialogVisible = true;
    }
  }
};
</script>

<style lang="scss" scoped></style>
